// Reusable ShimmerBar component
const ShimmerBar = ({ className }: { className?: string }) => (
  <div className={`bg-muted dark:bg-muted-foreground/20 animate-pulse rounded ${className}`} />
);

const MonthRowSkeleton = () => (
  <div className="grid grid-cols-3 items-center font-medium">
    {/* Incoming amount */}
    <div className="flex flex-grow flex-col justify-between items-start">
      <ShimmerBar className="w-16 h-6" />
    </div>
    
    {/* Month name */}
    <div className="flex flex-row items-center justify-center gap-1 text-center">
      <ShimmerBar className="w-3 h-3 rounded-full" />
      <ShimmerBar className="w-11 h-5 rounded-full" />
      <ShimmerBar className="w-3 h-3 rounded-full" />
    </div>
    
    {/* Outgoing amount */}
    <div className="flex flex-grow flex-col justify-between items-end">
      <ShimmerBar className="w-16 h-6" />
    </div>
  </div>
);

function MonthlyCashFlowSkeleton() {
  return (
    <div className="space-y-2">
      {[0, 1, 2].map((index) => (
        <MonthRowSkeleton key={index} />
      ))}
    </div>
  );
}

export default MonthlyCashFlowSkeleton; 
